export default function getUserDataFailed(error) {
    return {
        type: getUserDataFailed.type,
        payload: error,
    };
}

getUserDataFailed.type = 'GET_USER_DATA_FAILED';
